
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       <div class="form-div">
        <Form style="min-width: 550px" ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="权限名称" prop="name">
                <Input type="text" v-model="formData.name"></Input>
            </FormItem>
            <FormItem label="权限描述" prop="describe">
                <Input type="text" v-model="formData.describe"></Input>
            </FormItem>
            <FormItem label="路由" prop="route">
                <Input type="text" v-model="formData.route"></Input>
            </FormItem>
            <FormItem label="父级权限" prop="pid">
                <Select
				  v-model='formData.pid'
				  clearable
				  label-in-value>
				  <Option v-for="(item,index) in treeList" :value="item.id" :key="index">{{item.name}}</Option>
				</Select>
            </FormItem>
            <FormItem label="控制器加方法" prop="action">
                <Input type="text" v-model="formData.action"></Input>
            </FormItem>
            <FormItem label="HTTP方法" prop="method">
                <Input type="text" v-model="formData.method"></Input>
            </FormItem>
            <FormItem label="权限状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status" >
				  <Radio label="1" >
				  	<span>正常</span>
				  </Radio>
				  <Radio label="2" >
				  	<span>禁用</span>
				  </Radio>
                  <Radio label="3" >
				  	<span>禁删</span>
				  </Radio>
			    </RadioGroup>
            </FormItem>
            <FormItem label="权限类型" prop="type" class="ivu-form-item-required">
                <RadioGroup v-model="formData.type" >
				  <Radio label="1" >
				  	<span>菜单</span>
				  </Radio>
				  <Radio label="2" >
				  	<span>操作</span>
				  </Radio>
			    </RadioGroup>
            </FormItem>
            <FormItem label="强制校验" prop="is_check" class="ivu-form-item-required">
                <RadioGroup v-model="formData.is_check" >
				  <Radio label="1" >
				  	<span>正常</span>
				  </Radio>
				  <Radio label="2" >
				  	<span>禁用</span>
				  </Radio>
                  <Radio label="3" >
				  	<span>禁删</span>
				  </Radio>
			    </RadioGroup>
            </FormItem>
            <FormItem label="排序" prop="sorting">
                <Input type="text" v-model="formData.sorting"></Input>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
        </Form>

        <div class="right-ss">
            <div class="list">
                <div class="item" :class="listObj && listObj.action == item.action ?'activeP':''" v-for="(item,index) in list" :key="index" @click="selectA(item,index)">
                    <p><span>method:</span><span>{{item.method}}</span></p>
                    <p><span>route:</span><span>{{item.route}}</span></p>
                    <p><span>action:</span><span>{{item.action}}</span></p>
                </div>
            </div>
        </div>
       </div>

    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import TableModel from '@/views/common/tableModel'
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
      TableModel: TableModel,
      TableModel2: TableModel,
      TableModel3: TableModel
  },
  data() {
    return {
      title: "添加",
      disabled: false,
      list: [], //未添加路由列表
      listObj:'',
      treeList: [], //父级权限列表
      defaultData:{
        id: '',
        name: "",
        describe: "",
        route: "",
        action: "",
        method: "",
        status: "1",
        type: "1",
        is_check: "1",
        sorting: "100",
        pid: "",
        icon: "",
      },
      formData: {},
      ruleCustom: {
        name: [
          { required: true, message: "权限名称必须填写", trigger: "blur" },
        ],
        route: [
          { required: true, message: "路由必须填写", trigger: "blur" },
        ],
        action: [
          { required: true, message: "控制器加方法必须填写", trigger: "blur" },
        ],
        method: [
          { required: true, message: "method必须填写", trigger: "blur" },
        ],
        sorting: [
          { required: true, message: "排序必须填写", trigger: "blur" },
        ],
        pid: [
          { required: true, message: "父级权限必须填写", trigger: "blur" ,type: 'number'},
        ],
      },

    };
  },
  watch: {
    showModel(val) {
		if(val){
            this.getParsingData()
            this.getTreeData()
			if (this.type && this.type == 2) {
                this.title = '编辑'
				this.editForm()
			}
			if(this.type && this.type == 1){
                this.title = '添加'
				this.formData = this.defaultData
			}
		}
    },
  },
  methods: {
    editForm() {
	  for(let key in this.defaultData){
		  this.defaultData[key]=(this.editFormData[key] instanceof Array || this.editFormData[key] instanceof Object )?this.editFormData[key] : String(this.editFormData[key])
		  if(!this.editFormData[key]){
		    this.defaultData[key] = ''
		  }

      }
      this.defaultData.pid = Number(this.defaultData.pid)
      this.formData = this.defaultData;
      console.log('this.formData',this.formData)
    },
    selectA(item,index){
        this.listObj = item
        if(item){
            this.formData.action = item.action
            this.formData.method = item.method
            this.formData.route = item.route
        }

    },
    getParsingData(){ //获取数据
        this.axios.get(this.config.urlArray.permissionsParsing,{}).then((result) => {
            common.ajaxMsg(result.data);
            this.list = result.data.data
        }).catch((err) => {
            common.msg('error','获取失败',()=>{})
        });
    },
    getTreeData(){ //获取数据
        this.axios.get(this.config.urlArray.permissionsTree,{}).then((result) => {
            common.ajaxMsg(result.data);
            this.treeList = result.data.data
        }).catch((err) => {
            common.msg('error','获取失败',()=>{})
        });
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.axios
            .post(this.config.urlArray.permissionsStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm()
      this.fn();

    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      //重置表单
      this.defaultData = {
        id: '',
        name: "",
        describe: "",
        route: "",
        action: "",
        method: "",
        status: "1",
        type: "1",
        is_check: "1",
        sorting: "100",
        pid: "",
        icon: "",
      }
      this.formData.id = '';
      this.listObj = ''
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model{
    position: relative;
    .img-div{
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 45px;
        div{
            font-weight: bold;
            font-size: 15px;
        }
    }
    .close-img{
        border: 1px solid #fd6363;
        display: inline-block;
        line-height: 100%;
        border-radius: 100%;
        padding: 5px;
        color: #f00;
        right: 10px;
        top: 10px;
        z-index: 3;
        cursor: pointer;
    }
    .close-img:hover{
        transform: scale(1.1);
        transition: all 0.3s;
    }
}
.form-div{
    display: flex;
    .right-ss{
        padding-left: 20px;
        box-sizing: border-box;
        flex: 1;
        word-break: break-all;
        min-width: 300px;
        .list{
            max-height: 500px;
            overflow-y: auto;
            .item{
                cursor: pointer;
                margin: 10px 0px;
                border-bottom: 1px dashed #ccc;
                p{
                    display: flex;
                    span:nth-of-type(1){
                        font-weight: bold;
                        margin-right: 4px;
                        width: 60px;
                        display: inline-block;
                    }
                    span:nth-of-type(2){
                        flex: 1;
                        font-size: 12px
                    }
                }

            }
            .activeP{
                background: linear-gradient(to bottom, #25CBAE 0%,#CDFFF5 100%);
            }

        }
    }
}
</style>
